module.exports = __webpack_public_path__ + "img/VT.80ec604f.png";